<template>
  <div>
    <h4 class="text-uppercase">{{ $t("service_type") }}</h4>
    <h5>{{ $t("details") }}</h5>

    <info-field :label="$t('description')" :value="packageDetail.description" />
    <info-field :label="$t('delivery_service')" :value="toLatin(packageDetail.post.name)" />

    <p style="display: flex; justify-content: space-between">
      <info-field-inline
        :label="$t('weight')"
        :value="`${packageDetail.mass} kg`"
        style="width: 31%"
      />
      <info-field-inline
        :label="$t('package_opening')"
        :value="packageDetail.open == 1 ? $t('yes') : $t('no')"
        style="width: 31%"
      />
      <info-field-inline
        :label="$t('insurance')"
        :value="packageDetail.insurance == 1 ? $t('yes') : $t('no')"
        style="width: 31%"
      />
    </p>

    <p style="display: flex; justify-content: space-between">
      <info-field-inline
        :label="$t('width')"
        :value="`${packageDetail.width} cm`"
        style="width: 31%"
      />
      <info-field-inline
        :label="$t('length')"
        :value="`${packageDetail.height} cm`"
        style="width: 31%"
      />
      <info-field-inline
        :label="$t('height')"
        :value="`${packageDetail.length} cm`"
        style="width: 31%"
      />
    </p>

    <h5 class="mb-2">{{ $t("special_services") }}</h5>
    <p style="margin-bottom: 1px; padding-bottom: 1px">
      <label for="naplata">
        <input id="naplata" type="checkbox" />
        {{ $t("cash_on_delivery") }}
      </label>
    </p>
    <p style="margin-bottom: 1px; padding-bottom: 1px">
      <label for="vremenska">
        <input
          id="vremenska"
          :checked="localTimeDelivery"
          @change="$emit('update:time-delivery', $event.target.checked)"
          type="checkbox"
        />
        {{ $t("timed_delivery") }}
      </label>
    </p>
    <p v-if="localTimeDelivery" style="display: flex; justify-content: space-between">
      <span>{{ $t("from") }}: 12:00</span>
      <span>{{ $t("to") }}: 13:00</span>
    </p>
    <p style="margin-bottom: 1px; padding-bottom: 1px">
      <label for="ubrzano">
        <input id="ubrzano" type="checkbox" />
        {{ $t("express_delivery") }}
      </label>
    </p>

    <hr class="my-2" />

    <p style="display: flex; justify-content: space-between">
      <span>{{ $t("value") }}</span>
      <span
        style="padding: 1px 55px; border: 1px solid rgba(0, 0, 0, 0.12)"
        class="font-weight-black"
      >
        {{ parseFloat(packageDetail.price) }}
      </span>
    </p>
    <p style="display: flex; justify-content: space-between">
      <span>{{ $t("redemption_amount") }}</span>
      <span
        style="padding: 1px 55px; border: 1px solid rgba(0, 0, 0, 0.12)"
        class="font-weight-black"
      >
        {{ parseFloat(packageDetail.price) }}
      </span>
    </p>
  </div>
</template>

<script>
import InfoField from "./InfoField.vue";
import InfoFieldInline from "./InfoFieldInline.vue";

export default {
  name: "ServiceTypeDetails",
  components: {
    InfoField,
    InfoFieldInline,
  },
  props: {
    packageDetail: {
      type: Object,
      required: true,
    },
    timeDelivery: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    localTimeDelivery: {
      get() {
        return this.timeDelivery;
      },
      set(val) {
        this.$emit("update:time-delivery", val);
      },
    },
  },
};
</script>
